module.exports = __webpack_public_path__ + "static/media/address-e-red-icon.d8637a41.svg";